import * as React from "react";
import { cn } from "@/lib/utils";

interface NowRailProps {
  label: string;
}

export const NowRail = React.forwardRef<HTMLDivElement, NowRailProps>(
  function NowRail({ label }, ref) {
    return (
      <div
        ref={ref}
        className={cn(
          "flex items-center gap-2 px-3 my-2 select-none",
        )}
        aria-label={label}
        role="separator"
      >
        <span className="font-mono-num text-[10px] font-bold uppercase tracking-wider text-biz-now bg-biz-bg px-1.5 py-0.5 rounded animate-biz-now-pulse">
          {label}
        </span>
        <div className="h-px flex-1 bg-biz-now shadow-[0_0_8px_hsl(var(--biz-now)/0.6)]" />
        <div className="h-2 w-2 rounded-full bg-biz-now -ml-1" />
      </div>
    );
  },
);
